//logic for displaying alert messages which disappear after a certain time is stored here
export const alertMessagesMixin = {
  data() {
    return {
      dismissSecs: 1.5,
      dismissCountDown: 0
    }
  },

  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
